/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useSelector } from "react-redux";

// Helper Imports
import { formatMembershipProperties } from "../../../../Helpers/formatters";
import { validateEmail } from "../../../../Helpers/validateEmail";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";

// Component Imports
import EditModal from "../../../../Components/EditModal";
import CreateModal from "../../../../Components/CreateModal"
import Loading from "../../../../Components/Interactive/Loading";

const CustomerMemberships = ({
  allCustomerData,
  loading,
  setCustomerData,
  setUpdatedData,
  setTrigger
}) => {
  const {
    userMembershipInfo,
    userDetailsInfo: { customerId, ipAddress, campaignName, campaignId, brandId },
  } = allCustomerData;
  const userAuth = useSelector((state) => state.auth);
  const userId = userAuth?.userInfo?.userData?.userId;
  
  const [open, setIsOpen] = useState(true);
  const [toggleDropdown, setToggleDropdown] = useState(true);
  const [modalIsOpen, setModalOpen] = useState(false);
  const [createModalIsOpen, setCreateModalOpen] = useState(false);
  const [resetPasswordModalIsOpen, setResetPasswordModalOpen] = useState(false);

  // Update Membership Values
  const [expirationDate, setExpirationDate] = useState("");
  const [initialExpiration, setInitialExpiration] = useState("");
  const [userName, setUsername] = useState("");
  const [membershipId, setMembershipId] = useState("");
  const [isActive, setIsActive] = useState(false);

  // New Membership Values
  const [newMembershipUsername, setnewMembershipUsername] = useState('');
  const [newMembershipFirstName, setNewMembershipFirstName] = useState('');
  const [newMembershipLastName, setNewMembershipLastName] = useState('');
  const [newMembershipExpirationDate, setNewMembershipExpirationDate] = useState('');
  const [newMembershipVanityUrl, setNewMembershipVanityUrl] = useState('');

  const isInfluencerCampaign = (campaignName && campaignName.endsWith("Influencer")) ? true : false;

  // Event Handlers - Modals
  const handleOpen = (e) => setModalOpen(true);
  const handleClose = (e) => setModalOpen(false);
  const handleOpenNew = e => setCreateModalOpen(true);
  const handleCloseNew = e => setCreateModalOpen(false);
  const handleActive = (e) => setIsActive(e.target.checked);
  const handleOpenResetPassword = (e) => setResetPasswordModalOpen(true);
  const handleCloseResetPassword = (e) => setResetPasswordModalOpen(false);

  // Update an existing membership
  const submitMembershipUpdate = async () => {
    const isValid = validateEmail(userName);
    if (!isValid) {
      alert("Please enter a valid email address");
      return;
    }
    const options = {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Username: userName,
        ExpirationDate: expirationDate,
        Active: isActive,
        MembershipId: membershipId,
        CustomerId: customerId,
        UserId: userId,
        OldExpirationDate: initialExpiration
      }),
    };

    const res = await fetch(`/api/customer/${customerId}/update-membership`, options);
    const { success, hasExistingMembershipUsername } = await res.json();

    let memberUpdateMessage;
    let status = success;
    if (!success) {
      memberUpdateMessage = "Failed to update membership.";
    }
    else if (hasExistingMembershipUsername) {
      memberUpdateMessage = "Membership updated successfully but could not update Email: email already in use on an existing membership.";
      status = false;
    }
    else {
      memberUpdateMessage = "Membership updated successfully.";
    }

    if (success) {
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateData,
          state: status ? true : false,
          message: memberUpdateMessage
        },
      }));
      setTrigger("GET_MEMBERSHIPS");
      setTrigger("");
    }
    setModalOpen(false);
  };

  // Create a new membership
  const submitMembershipNew = async () => {
    const isValid = validateEmail(newMembershipUsername);
    if (!isValid) {
      alert("Please enter a valid email address");
      return;
    }
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserId: +userId,
        CustomerId: +customerId,
        BrandId: +brandId,
        Username: newMembershipUsername,
        FirstName: newMembershipFirstName,
        LastName: newMembershipLastName,
        ExpirationDate: newMembershipExpirationDate,
        VanityUrl: newMembershipVanityUrl,
        CampaignId: isInfluencerCampaign ? campaignId : null,
        IpAddress: ipAddress
      }),
    };

    const res = await fetch(`/api/customer/${customerId}/create-membership`, options);
    const isSuccess = await res.json();

    if(isSuccess) {
      setCustomerData((prevState) => ({
        userDetailsInfo: prevState.userDetailsInfo,
        userOrders: prevState.userOrders,
        userPaymentInfo: prevState.userPaymentInfo,
        userCallNotesInfo: prevState.userCallNotesInfo,
        userEmailNotesInfo: prevState.userEmailNotesInfo,
        userMembershipInfo: {
          ...prevState.userMembershipInfo,
          membershipInfo: prevState.userMembershipInfo.membershipInfo.map(
            (membership, i) => {
                return membership;
            }
          ),
        },
        userTrackingInfo: prevState.userTrackingInfo,
        userProgramsInfo: prevState.userProgramsInfo,
        userLoginHistoryInfo: prevState.userLoginHistoryInfo,
        dispositions: prevState.dispositions,
        userEvents: prevState.userEvents,
        userReportHistory: prevState.userReportHistory,
        userCallLog: prevState.userCallLog,
        userLockouts: prevState.userLockouts,
        userReportDownloads: prevState.userReportDownloads
      }));

      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateData,
          state: isSuccess ? true : false,
          message: isSuccess
            ? "Membership added successfully"
            : "Failed to add new membership",
        },
      }));
    }
    setCreateModalOpen(false);
    setTrigger("GET_MEMBERSHIPS");
  }

  const isDefined = () => userMembershipInfo && userMembershipInfo.membershipInfo && userMembershipInfo.membershipInfo.length > 0;

  const setCurrentlyEdited = (index, membership) => {
    const { memberUsername, memberExpirationDate, membershipId, active } = membership;
    setInitialExpiration(memberExpirationDate.split(' ')[0]);
    setExpirationDate(memberExpirationDate.split(' ')[0]);
    setUsername(memberUsername);
    setMembershipId(membershipId);
    setIsActive(active)
    handleOpen();
  }

  return (
    <div
      className={`user-data-container ${
        isDefined() ? "" : "user-data-container-squeezed"
      } ${open ? "show-memberships-widget" : "hide-memberships-widget"}`}
      style={{marginBottom: "1rem"}}
    >
      <div className="customer-widget-header">
        <p className="customer-widget-heading" style={{ width: "8rem" }}>
          Memberships
        </p>
        {open && (
          <div style={{display: "flex", alignItems: "center", justifyContent: "space-evenly", width: "4rem"}}>
            <AddCircleOutlineIcon className="edit-info-btn" onClick={handleOpenNew}/>
          </div>
        )}
        {isDefined() && (
          <ArrowDropDownIcon
            onClick={() => {
              setIsOpen(!open);
              setToggleDropdown(!toggleDropdown);
            }}
            className={`arrow-dropdown ${
              toggleDropdown ? "arrow-open" : "arrow-close"
            }`}
          />
        )}
      </div>

      <div className={`data-push ${open ? "show-data" : "no-data"}`}>
        {loading ? (
          <div className="loading-widget">
            <Loading />
          </div>
        ) : (
          <>
            {isDefined() ? (
              formatMembershipProperties(userMembershipInfo.membershipInfo, setCurrentlyEdited, handleOpenResetPassword)
            ) : (
              <h3 style={{ fontSize: "1rem" }}>No Memberships</h3>
            )}

            <EditModal
              open={resetPasswordModalIsOpen}
              handleClose={handleCloseResetPassword}
            >
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6" }}>
                  Reset Password
                </h2>
                <CloseIcon
                  className="close-icons"
                  onClick={handleCloseResetPassword}
                />
              </div>
              <p style={{ padding: "1rem" }}>
                Ask user to Reset password from their login page
              </p>
            </EditModal>

            <EditModal open={modalIsOpen} handleClose={handleClose}>
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6" }}>
                  Edit Membership Details
                </h2>
                <CloseIcon
                  className="close-icons"
                  onClick={handleClose}
                />
              </div>
              <TextField
                id="outlined-full-width"
                className="input-el"
                label="Membership Username"
                name="member_username"
                style={{ margin: 10, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={userName}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                id="outlined-full-width"
                className="input-el"
                type="date"
                label="Membership Expiration Date"
                name="expiration_Date"
                style={{ margin: 8, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={expirationDate}
                onChange={(e) => setExpirationDate(e.target.value)}
              />
              <Checkbox checked={isActive} onChange={handleActive} color="secondary" />
              <small>Active</small>
              <div className="modal-btn-box">
                <button className="submit-btn" onClick={submitMembershipUpdate}>
                  <span>Submit</span>
                </button>
              </div>
            </EditModal>
            <CreateModal open={createModalIsOpen} handleClose={handleCloseNew} customCSS={{height: isInfluencerCampaign ? "520px" : "450px"}} >
              <div className="modal-header">
                <h2 style={{ padding: ".5rem", color: "#6acde6" }}>
                  Create New Membership
                </h2>
                <CloseIcon
                  className="close-icons"
                  onClick={ handleCloseNew}
                />
              </div>
              <TextField
                id="outlined-full-width"
                className="input-el"
                label="First Name"
                name="member_fname"
                style={{ margin: 10, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={newMembershipFirstName}
                onChange={(e) => setNewMembershipFirstName(e.target.value)}
              />
              <TextField
                id="outlined-full-width"
                className="input-el"
                label="Last Name"
                name="member_lname"
                style={{ margin: 10, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={newMembershipLastName}
                onChange={(e) => setNewMembershipLastName(e.target.value)}
              />
              <TextField
                id="outlined-full-width"
                className="input-el"
                label="Membership Username"
                name="member_username"
                style={{ margin: 10, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={newMembershipUsername}
                onChange={(e) => setnewMembershipUsername(e.target.value)}
              />
              <TextField
                id="outlined-full-width"
                className="input-el"
                type="date"
                label="Membership Expiration Date"
                name="expiration_Date"
                style={{ margin: 8, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={newMembershipExpirationDate}
                onChange={(e) => setNewMembershipExpirationDate(e.target.value)}
              />
              {
              isInfluencerCampaign &&
              <TextField
                id="outlined-full-width"
                className="input-el"
                label="Vanity Url"
                name="vanity_url"
                style={{ margin: 8, width: "96%" }}
                fullWidth={false}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={newMembershipVanityUrl}
                onChange={(e) => setNewMembershipVanityUrl(e.target.value)}
              />
              }
              <div className="modal-btn-box">
                <button className="submit-btn" onClick={submitMembershipNew} style={{position: "fixed", bottom: "2.3rem", right: "left: 2rem"}}>
                  <span>Submit</span>
                </button>
              </div>
            </CreateModal>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerMemberships;
